module.exports = __webpack_public_path__ + "img/product_sk-ii_1@2x.2dbb43a1.png";